import React from 'react';
import InlineGroupStyles from './InlineGroup.module.css';

export function InlineGroup(props) {
  return <div className={InlineGroupStyles['inline-group']}>{props.children}</div>;
}
